<template>
  <div class="e-charts w100 h100" @resize="reSize++">
    <div class="w100 h100" ref="chartSize" v-if="!showEchart" :key="reSize"></div>
    <div class="w100 h100 mlr-auto" ref="chart" :style="styleObj" v-else :key="reSize + 1000"></div>
  </div>
</template>

<script>
  export default {
    name: "ECharts",
    props: {
      width: {
        type: String,
        default: '',
      },
      height: {
        type: String,
        default: '',
      },
      proportion: {
        // 宽高比
        type: String | Number,
        default: 550 / 400
      },
      options: {
        type: Object,
        default() {
          return {}
        },
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      options(val) {
        this.myChart[this.loading ? 'showLoading' : 'hideLoading']();
        this.initEChart();
      },
      loading(val) {
        if (this.myChart) {
          this.myChart[val ? 'showLoading' : 'hideLoading']();
        }
      },
      styleObj() {
        this.initEChart();
      },
    },
    computed: {
      styleObj() {
        let {width, height, proportion, dom, reSize} = this;
        if (dom) {
          let {offsetWidth: w, offsetHeight: h} = dom;
          let unit = 'px';
          width.indexOf('%') > 0 && (width = w * parseInt(width) / 100 | 0);
          height.indexOf('%') > 0 && (height = w * parseInt(height) / 100 | 0);
          if (!width && height) {
            width = proportion ? Math.min(w, height * proportion | 0) : 0;
          } else if (width && !height) {
            height = proportion ? width / proportion | 0 : 0;
          } else if (proportion && !width && !height) {
            width = w;
            height = w / proportion | 0;
          }

          (width + '').indexOf(unit) > 0 || (width += unit);
          (height + '').indexOf(unit) > 0 || (height += unit);
          return {width, height};
        } else {
          return {};
        }
      },
    },
    data() {
      return {
        myChart: null,
        dom: null,
        showEchart: false,
        reSize: 0,
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.dom = this.$refs.chartSize;
      });
      window.removeEventListener('resize', this.reload);
      window.addEventListener('resize', this.reload);
    },
    methods: {
      reload() {
        this.showEchart = false;
        this.$nextTick(() => {
          this.dom = this.$refs.chartSize;
          this.reSize++;
        });
      },

      initEChart() {
        this.showEchart = true;
        this.$nextTick(() => {
          let myChart = this.echarts.init(this.$refs.chart);
          this.myChart = myChart;
          myChart.clear();
          this.options.title = this.options.title || {};
          this.options.title.textStyle = this.options.title.textStyle || {};
          this.options.title.textStyle.fontSize = 16;
          myChart.setOption({
            color: [
              '#2ec7c9', '#b6a2de', '#5ab1ef', '#ffb980', '#d87a80',
              '#8d98b3', '#e5cf0d', '#97b552', '#95706d', '#dc69aa',
              '#07a2a4', '#9a7fd1', '#588dd5', '#f5994e', '#c05050',
              '#59678c', '#c9ab00', '#7eb00a', '#6f5553', '#c14089'
            ],
            ...this.options,
          });
        });
      },
    },
  }
</script>

<style scoped>

</style>
